import { render } from "./ChatRoomNew.vue?vue&type=template&id=abcd98c4&scoped=true"
import script from "./ChatRoomNew.vue?vue&type=script&lang=js"
export * from "./ChatRoomNew.vue?vue&type=script&lang=js"

import "./ChatRoomNew.vue?vue&type=style&index=0&id=abcd98c4&lang=css"
import "./ChatRoomNew.vue?vue&type=style&index=1&id=abcd98c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abcd98c4"]])

export default __exports__